module.exports = __webpack_public_path__ + "b51ab54cb00fedd475f00d4701c0056d.svg";